import { Component, HostBinding, Input } from '@angular/core';
import { StoreService } from '../../services/store.service';
import { DomSanitizer } from '@angular/platform-browser';

export interface SocialLinksItem {
    type: string;
    url: string;
    icon: string;
}

export type SocialLinksShape = 'circle' | 'rounded';

@Component({
    selector: 'app-social-links',
    templateUrl: './social-links.component.html',
    styleUrls: ['./social-links.component.scss']
})
export class SocialLinksComponent {

    items: SocialLinksItem[] = [
        {type: 'facebook', url: "", icon: 'fab fa-facebook-f'},
        {type: 'youtube', url: "", icon: 'fab fa-youtube'},
        {type: 'instagram', url: "", icon: 'fab fa-instagram'},
    ];

    @Input() shape: SocialLinksShape;

    @HostBinding('class.social-links') classSocialLinks = true;

    @HostBinding('class.social-links--shape--circle') get classSocialLinksShapeCircle(): boolean { return this.shape === 'circle'; }

    @HostBinding('class.social-links--shape--rounded') get classSocialLinksShapeRounded(): boolean { return this.shape === 'rounded'; }

    noUrl;

    constructor(private store : StoreService, private sanitizer : DomSanitizer) {
        let links = this.store.link_social;
        if (links) {
            for (let link of links) {
                let found = this.items.find(item => item.type == link.type);
                if (found)
                    found.url = link.url;
            }
        }

        this.noUrl = this.sanitizer.bypassSecurityTrustUrl('#');
    }

    openLink(item) {
        if (item.url)
            window.open(item.url, '_blank');
    }
}
